require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-claire-ibbot.json") })
        }
      }, "path---people-claire-ibbot");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-claire-ibbot!./.cache/json/people-claire-ibbot.json
// module id = 1450
// module chunks = 231608221292675